import { Box, Text } from "@modernatx-internal/component-library";

import { useExperience } from "@/context/ExperienceContext";
import { useFinder } from "@/finder/hooks/V2/useFinder";
import { pharmacyLogos, pharmacyLogosAdditionalPadding } from "@/finder/utils/pharmacyLogos";
import type { FinderLocation } from "@/types/FinderLocation";

export const LocationDetails = ({ location }: { location: FinderLocation }): React.ReactNode => {
  const { streetAddress, city, stateProvince } = location.location;
  const { name, phoneNumber } = location.customer;

  const { country } = useExperience();
  const { showPharmacyLogos } = useFinder();
  const logoUrl = showPharmacyLogos && name ? pharmacyLogos[name] : undefined;
  const logoPadding = name ? pharmacyLogosAdditionalPadding[name] : undefined;

  return (
    <Box>
      {logoUrl ? (
        // eslint-disable-next-line @next/next/no-img-element
        <img
          src={logoUrl}
          alt={`${name} logo`}
          style={{
            display: "block",
            height: "2rem",
            marginBottom: logoPadding ? logoPadding : "0.15rem",
            maxWidth: "100%"
          }}
        />
      ) : (
        <Text variant="h5" sx={{ color: "text-emphasis" }}>
          {name}
        </Text>
      )}
      {streetAddress && (
        <Text variant="body-1-regular">
          {country === "jp" ? city + streetAddress : `${streetAddress}, ${city}, ${stateProvince}`}
        </Text>
      )}
      {phoneNumber && (
        <Text variant="body-1-regular">
          <br />
          {country === "jp" ? `TEL: ${phoneNumber}` : phoneNumber}
        </Text>
      )}
    </Box>
  );
};
